import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.promise.js";
import { isAliPay, isWXAppBrowser, isWXBrowser, reportError } from '@/utils';
/** SDK URL 常量：与原 index.html defer 标签中的 URL 逐字一致 */

var WX_SDK_URL = 'https://design.tinman.cn/library/weixin-js-sdk/0.0.2/weixin-js-sdk.2023112135351.js';
/** alipayjsapi 3.1.1：自托管至自有 CDN（design.tinman.cn），与支付宝官方源逐字节一致 */

var ALIPAY_SDK_URL = 'https://design.tinman.cn/library/public/3.2.0/alipayjsapi.inc.min.2026731101023.js';
/** tdid-build 2.1.0：与原 index.html defer 标签 URL 逐字一致 */

var TDID_URL = 'https://design.tinman.cn/library/public/1.2.7/tdid-build-2.1.0-20100-236e451cfd70e15b-nolog_all_20240719194221.2025626103656.js';
/** Promise 按 URL 缓存，重复调用幂等 */

var promiseCache = new Map();
/**
 * 通用注入：document.createElement('script')（动态脚本默认 async，不进 defer 队列、不卡 DCL）
 * onload → resolve(true)；onerror → 重试 1 次（重建标签）；再失败 → reportError + resolve(false)
 * 若目标全局变量已存在（globalCheck 返回 true）直接 resolve(true)
 */

function injectScript(url, globalCheck) {
  // 缓存命中：同一 URL 返回同一 Promise
  var cached = promiseCache.get(url);

  if (cached) {
    return cached;
  }

  var promise = new Promise(function (resolve) {
    // 目标全局变量已存在，直接 resolve
    if (globalCheck()) {
      resolve(true);
      return;
    }

    var retried = false;

    var createScript = function createScript() {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;

      script.onload = function () {
        resolve(true);
      };

      script.onerror = function () {
        // 清理失败标签
        script.remove();

        if (!retried) {
          retried = true; // 重试 1 次（重建标签）

          createScript();
        } else {
          // 再失败：上报 + resolve(false)，不 reject
          reportError(new Error("sdkLoader: failed to load ".concat(url)));
          resolve(false);
        }
      };

      document.head.appendChild(script);
    };

    createScript();
  });
  promiseCache.set(url, promise);
  return promise;
}
/**
 * 微信 SDK：仅 isWXBrowser() || isWXAppBrowser() 环境注入，
 * 其余环境立即 resolve(false)（不发无效请求）
 */


export function loadWxSdk() {
  if (!isWXBrowser() && !isWXAppBrowser()) {
    return Promise.resolve(false);
  }

  return injectScript(WX_SDK_URL, function () {
    return typeof window.wx !== 'undefined';
  });
}
/**
 * 支付宝 SDK：仅 isAliPay() 环境注入，其余环境立即 resolve(false)
 * 就绪信号只认 window.ap（alipayjsapi 脚本执行后创建）；
 * AlipayJSBridge 由支付宝容器原生注入、不代表 SDK 已加载，不得作为短路依据，
 * 否则 SDK 永不注入，消费端引用 ap 时会抛 ReferenceError
 */

export function loadAlipaySdk() {
  if (!isAliPay()) {
    return Promise.resolve(false);
  }

  return injectScript(ALIPAY_SDK_URL, function () {
    return typeof window.ap !== 'undefined';
  });
}
/**
 * tdid：所有环境注入（现状即所有环境加载），
 * 返回 Promise 供将来按需等待
 */

export function loadTdid() {
  return injectScript(TDID_URL, function () {
    return false;
  });
}
/**
 * 入口预热：landing 入口模块顶部调用，
 * 仅按环境立即发起 loadAlipaySdk（weixin-js-sdk 已通过 defer 加载，
 * tdid 延迟至主内容渲染完成后加载）
 */

export function initEagerLoad() {
  loadAlipaySdk();
}